import {
  ClockRehydrator,
  SiteFooterRehydrator,
  SiteHeaderRehydrator
} from "@arc-ui/components";
import reactFromHTML from "react-from-html";

const roots = document.querySelectorAll(".arc");

for (let i = 0; i < roots.length; i++) {
  const root = roots[i];

  reactFromHTML(root, {
    ".arc-Clock": ClockRehydrator,
    ".arc-SiteFooter-disclosure": SiteFooterRehydrator,
    ".arc-SiteHeader": SiteHeaderRehydrator,
    ".arc-SiteHeaderItemGroup": SiteHeaderRehydrator.ItemGroupRehydrator,
    ".arc-SiteHeaderNavItem": SiteHeaderRehydrator.NavItemRehydrator,
    ".arc-SiteHeaderNavItemWithSubNav":
      SiteHeaderRehydrator.NavItemWithSubNavRehydrator,
    ".arc-SiteHeaderSubNavItem": SiteHeaderRehydrator.SubNavItemRehydrator
  });
}
